'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');

const isNumber = (value) => typeof value === "number";
const Styles = styleEncapsulation.labelStyles("Grid", {
  root: (props) => react.css({
    display: "grid",
    alignItems: props.alignItems,
    gap: props.gap,
    gridTemplateColumns: isNumber(props.columns) ? `repeat(${props.columns}, 1fr)` : props.columns
  })
});
const Grid = (props) => {
  return react.jsx("div", { css: Styles.root(props), "data-zds": true }, props.children);
};

exports.Grid = Grid;
//# sourceMappingURL=Grid.cjs.js.map
